import { render, staticRenderFns } from "./DependencyModal.vue?vue&type=template&id=15a1c7ba&scoped=true"
import script from "./DependencyModal.vue?vue&type=script&lang=js"
export * from "./DependencyModal.vue?vue&type=script&lang=js"
import style0 from "./DependencyModal.vue?vue&type=style&index=0&id=15a1c7ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a1c7ba",
  null
  
)

export default component.exports